import { Stack, Typography } from '@mui/material';
import { ControllerDatePicker, RadioButtons } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext, useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { CaseDetailsSlice, store } from 'Store';

export const SpecificOrOverTimeInjury = () => {
  const { index } = useContext(IndexContext);

  const baseName = `caseDetails.${index}`;

  const [releaseDate, isSpecificEvent] = useWatch({
    name: [
      `${baseName}.militaryServiceSection.releaseDate`,
      `${baseName}.isCausedBySpecificEvent`,
    ],
  });

  useEffect(() => {
    store.dispatch(
      CaseDetailsSlice.actions.setIsMentalIllnessCausedBySpecificEvent({
        id: index,
        type: isSpecificEvent,
      })
    );
  }, [isSpecificEvent, index]);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  return (
    <Stack sx={{ mb: '20px' }}>
      <Typography sx={{ fontWeight: 'bold' }}>
        {dictionary.secondSectionMentalTitle}
      </Typography>
      <RadioButtons
        id={dictionary.secondSectionMentalLabel}
        name={`${baseName}.isCausedBySpecificEvent`}
        options={[
          {
            value: 'true',
            label: dictionary.secondSectionMentalShort,
          },
          {
            value: 'false',
            label: dictionary.secondSectionMentalLong,
          },
        ]}
      />

      {isSpecificEvent && (
        <>
          <br />
          <ControllerDatePicker
            name={`${baseName}.injuryKindSection.date`}
            label={dictionary.fourthSectionFirstInput}
            maxDate={new Date()}
          />
        </>
      )}
    </Stack>
  );
};
